var map = {
	"./descriptions": 594,
	"./descriptions.json": 594,
	"./images/action.jpg": 3825,
	"./images/adventure.jpg": 9555,
	"./images/card.jpg": 1037,
	"./images/fantasy.jpg": 2489,
	"./images/horror.jpg": 6883,
	"./images/mech.jpg": 3980,
	"./images/multiplayer.jpg": 3511,
	"./images/post-apocalyptic.jpg": 7237,
	"./images/puzzle.jpg": 675,
	"./images/rogue-like.jpg": 5485,
	"./images/rpg.jpg": 206,
	"./images/sci-fi.jpg": 3816,
	"./images/shooter.jpg": 1859,
	"./images/souls-like.jpg": 7739,
	"./images/stealth.jpg": 782,
	"./images/strategy.jpg": 6012,
	"./links": 8546,
	"./links.json": 8546,
	"./modals": 6447,
	"./modals.json": 6447,
	"./origin": 1260,
	"./origin.json": 1260
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7902;